import YASQE from "@triply/yasqe";
import namespaces from '../utils/namespaces';

const tokenTypes = {
    "string-2": "prefixed",
    "atom": "var",
};

const NS_MAPPING = Object.keys(namespaces).map((key) => namespaces[key] + ": <" + key + ">").sort();

const prefixCompleter = {

    onInitialize: function (yasqe) {
        yasqe.on("change", () => {
            var cur = yasqe.getDoc().getCursor();
            var token = yasqe.getTokenAt(cur);
            if (token.type && tokenTypes[token.type] == "prefixed") {
                var colonIndex = token.string.indexOf(":");
                if (colonIndex !== -1) {
                    // check previous token isnt PREFIX, or a '<'(which would mean we are in a uri)
                    //			var firstTokenString = yasqe.getNextNonWsToken(cur.line).string.toUpperCase();
                    var lastNonWsTokenString = yasqe.getPreviousNonWsToken(cur.line, token).string.toUpperCase();
                    var previousToken = yasqe.getTokenAt({
                        line: cur.line,
                        ch: token.start,
                    }); // needs to be null (beginning of line), or whitespace

                    if (
                        lastNonWsTokenString !== "PREFIX" &&
                        (previousToken.type == "ws" ||
                            previousToken.type == null ||
                            (previousToken.type === "punc" &&
                                (previousToken.string === "|" ||
                                    previousToken.string === "/" ||
                                    previousToken.string == "^^" ||
                                    previousToken.string == "{" ||
                                    previousToken.string === "(")))
                    ) {
                        // check whether it isn't defined already (saves us from looping
                        // through the array)
                        var currentPrefix = token.string.substring(0, colonIndex + 1);
                        var queryPrefixes = yasqe.getPrefixesFromQuery();
                        if (queryPrefixes[currentPrefix.slice(0, -1)] == null) {
                            // ok, so it isn't added yet!
                            token.autocompletionString = currentPrefix;
                            yasqe.autocompleters[this.name]?.getCompletions(token).then((suggestions) => {
                                if (suggestions.length) {
                                    yasqe.addPrefixes(suggestions[0]);
                                    // Re-activate auto-completer after adding prefixes, so another auto-completer can kick in
                                    yasqe.autocomplete();
                                }
                            }, console.warn);
                        }
                    }
                }
            }
        });
    },
    isValidCompletionPosition: function (yasqe) {
        return YASQE.Autocompleters.prefixes.isValidCompletionPosition(yasqe);
    },
    preProcessToken: function (yasqe, token) {
        return YASQE.Autocompleters.prefixes.preProcessToken(yasqe, token);
    },
    name: "prefixCompleter",
    bulk: true,
    async: false,
    autoShow: true,
    persistent: false,
    get: function () {
        return NS_MAPPING;
    }

};

export default prefixCompleter;